<app-paired-autocomplete #compareFieldPicker
                         [selectedFieldControl]="compareFieldControl"
                         [secondaryEntityControl]="compareFieldSecondaryDescriptorControl"
                         [primaryEntity]="primaryEntity"
                         [componentId]="'criteria-compareField'"
                         [entitiesOptions]="entitiesOptions"
                         [placeholder]="'Choose a field...'"
                         [overlayPositioningConfig]="overlayPositioningConfig">
</app-paired-autocomplete>
